var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Defaults, Watch, PropertyConverters } from '@pacem/pacem-core';
import { buildWidgetMetadata, EXPRESSION_WIDGET_METADATA_EXTRA } from '../types';
import { EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
import { PacemUiWidgetElement } from './types';
//namespace Pacem.Components.Cms {
const TEXT_METADATA = buildWidgetMetadata({
    display: { icon: 'font_download', name: 'Text', description: 'Plain text widget.' },
    props: [{
            prop: 'text', type: EXPRESSION_METADATA_TYPE, display: { name: 'Text' }, extra: EXPRESSION_WIDGET_METADATA_EXTRA
        }]
});
let PacemWidgetTextElement = class PacemWidgetTextElement extends PacemUiWidgetElement {
    constructor() {
        super(TEXT_METADATA);
    }
};
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemWidgetTextElement.prototype, "text", void 0);
PacemWidgetTextElement = __decorate([
    CustomElement({
        tagName: P + '-widget-text', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-text text="{{ :host.text }}"></${P}-text>`
    })
], PacemWidgetTextElement);
export { PacemWidgetTextElement };
